import React, { useEffect, useState } from "react";
import {
  Card,
  Box,
  Button,
  Typography,
  useMediaQuery,
  IconButton,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { withStyles } from "@mui/styles";
import { Edit } from "@mui/icons-material";
import { ChevronLeft } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useHistory, Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

const MainTemplateHeader = (props) => {
  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const history = useHistory();
  const matches = useMediaQuery("(max-width:900px)");
  const {
    title,
    handleBackClick,
    backTitle,
    noBack,
    noTitle,
    showSearch,
    selectedDosage,
    selectedQuantity,
    selectedForm,
    openSearchSettings,
    fromPOSViewCoupon = false,
    fromModifyScreen = false,
    organizationInfo,
  } = props;

  const [showTooltip, setToolTip] = useState(true);
  const couponViewCount = localStorage.getItem("coupon_view_count");

  const BlueOnBlueTooltip = withStyles({
    arrow: {
      "&:before": {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        border: `${theme.palette.secondary.main} !important`,
      },
    },
    tooltip: {
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
  })(Tooltip);

  useEffect(() => {
    setTimeout(() => {
      setToolTip(false);
    }, 5000);
  }, []);

  return (
    <Card
      sx={{
        width: fromModifyScreen ? "100%" : undefined,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        boxShadow: 0,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          padding: "0px",
          backgroundColor: theme.palette.common.bgGrey2,
          position: "relative",
          height: matches ? "80px" : "85px",
          display: fromPOSViewCoupon ? "none" : "bloc",
        }}
      >
        <Button
          variant="outline"
          sx={{
            position: "absolute",
            left: "16px",
            height: matchesMinWidth ? "30px" : "40px",
            minWidth: matchesMinWidth ? "38px" : undefined,
            top: "13px",
            padding: backTitle ? "4px 12px 4px 0" : "4px 0px",
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: "#fff",
            },
            visibility: !fromModifyScreen ? "visible" : "hidden",
          }}
          onClick={() => {
            if (handleBackClick) {
              handleBackClick();
            }
            !noBack && history.goBack();
          }}
        >
          <ChevronLeft
            fontSize="large"
            sx={{ color: theme.palette.common.greenTwo, cursor: "pointer" }}
          />
          {backTitle ? "BACK" : ""}
        </Button>
        <Box
          sx={{
            display: fromModifyScreen ? "flex" : undefined,
            alignItems: fromModifyScreen ? "center" : undefined,
            justifyContent: fromModifyScreen ? "center" : undefined,
            height: fromModifyScreen ? "100%" : undefined,
          }}
        >
          <Typography
            sx={{
              fontSize: matchesMinWidth ? "20px" : "28px",
              fontFamily: "Lato-Regular",
              color: theme.palette.primary.main,
              minHeight: matchesMinWidth ? 20 : 30,
            }}
          >
            {noTitle ? "" : title || "Title"}
          </Typography>
          {organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
            "y" &&
            !fromModifyScreen &&
            (selectedQuantity || selectedDosage) && (
              <Typography
                sx={{
                  //paddingLeft: "1.5rem",
                  fontSize: matchesMinWidth ? "14px" : "16px",
                  fontFamily: "Lato-Regular",
                  color: theme.palette.primary.main,
                  minHeight: matchesMinWidth ? 20 : 30,
                  width: "80%",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                }}
              >
                {selectedDosage ? `${selectedDosage}, ` : ""}
                {selectedQuantity &&
                  `${selectedQuantity + " " + (selectedForm || "")}`}

                {openSearchSettings &&
                  organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
                    "y" && (
                    <>
                      {couponViewCount <= 5 ? (
                        <BlueOnBlueTooltip
                          id="BlueOnBlueTooltip"
                          open={showTooltip}
                          title={
                            <Typography
                              sx={{
                                fontSize: matchesMinWidth ? "16px" : "20px",
                                fontFamily: "Lato-Regular",
                                color: theme.palette.secondary.hoverOneText,
                                height: "60px",
                                textAlign: "center",
                              }}
                              component={"div"}
                            >
                              Please verify <br />
                              dosage!
                            </Typography>
                          }
                          arrow
                          color={theme.palette.secondary.main}
                        >
                          <IconButton
                            onClick={() => {
                              openSearchSettings();
                            }}
                            edge="end"
                          >
                            <Edit
                              sx={{ color: theme.palette.secondary.main }}
                            />
                          </IconButton>
                        </BlueOnBlueTooltip>
                      ) : (
                        <IconButton
                          onClick={() => {
                            openSearchSettings();
                          }}
                          edge="end"
                        >
                          <Edit sx={{ color: theme.palette.secondary.main }} />
                        </IconButton>
                      )}
                    </>
                  )}
              </Typography>
            )}
        </Box>
        {showSearch ? (
          <Box
            component={Link}
            to="/"
            sx={{
              position: "absolute",
              right: matchesMinWidth ? "4px" : "10px",
              top: matchesMinWidth ? "4px" : "10px",
            }}
          >
            <IconButton color="primary" aria-label="search">
              <SearchIcon
                sx={{
                  color: theme.palette.secondary.main,
                  width: "2rem",
                  height: "2rem",
                }}
              />
            </IconButton>
          </Box>
        ) : null}
      </Box>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

export default connect(mapStateToProps)(MainTemplateHeader);